import {ChangeDetectionStrategy, Component, computed, input} from '@angular/core';
import {RouterLink} from '@angular/router';
import {ElciaCard} from '../../../../components/card/card';

@Component({
  selector: 'elcia-dashboard-kpi-tile',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ElciaCard, RouterLink],
  templateUrl: './dashboard-kpi-tile.html',
  host: {class: 'block min-w-0'},
})
export class DashboardKpiTile {
  label = input.required<string>();
  value = input.required<string>();
  icon = input.required<string>();
  link = input.required<string>();
  hint = input<string>();

  // null = no comparison available (no history yet): the tile shows a dash, never a misleading 0%.
  deltaPercent = input<number | null>(null);

  protected readonly deltaLabel = computed(() => {
    const delta = this.deltaPercent();
    if (delta === null) return '—';
    return `${delta > 0 ? '+' : ''}${delta.toFixed(0)} %`;
  });

  protected readonly deltaClass = computed(() => {
    const delta = this.deltaPercent();
    if (delta === null) return 'text-[var(--p-surface-400)]';
    return delta >= 0 ? 'text-emerald-600' : 'text-red-600';
  });
}
